module.exports = __webpack_public_path__ + "img/logo-w-p.cbd9d74a6d249b698a8305626c46851f.svg";